var map = {
	"./arrows-down.svg": 71615,
	"./arrows-up.svg": 18640,
	"./backTop.svg": 450,
	"./call/email.svg": 16873,
	"./call/phonecall.svg": 56033,
	"./call/region.svg": 59707,
	"./call/websit.svg": 33685,
	"./content/success.svg": 78527,
	"./enter.svg": 55142,
	"./file_doc.svg": 81673,
	"./file_non.svg": 47866,
	"./file_pdf.svg": 92757,
	"./file_ppt.svg": 68083,
	"./file_xls.svg": 92264,
	"./phonecall.svg": 94504,
	"./service.svg": 47085,
	"./summary-bg.svg": 53844
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43655;